import css from './LinkButton.module.css';
import {ButtonHTMLAttributes, PropsWithChildren} from "react";

export const LinkButton = (props: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const buttonProps = {...props, className: css.link};

  return <button {...buttonProps}>{props.children}</button>
}